import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { startLoading, doneLoading } from '../../utils/loading'
import ProjectStatusDataTable from '../dataTable/ProjectStatusDataTable'
import { getProjectStatusPending, searchProjectStatusPending } from '../../redux/actions/dashboard'
import DashboradToggle from '../dashboard/DashboradToggle'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function ProjectStatusPending({ config, onSettingChange = () => {} }) {
  const [loading, setloading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  let history = useHistory()

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handelGetSchemaDashboard()
    }
  }, [])

  const handelGetSchemaDashboard = async () => {
    setloading(true)
    // startLoading()
    try {
      const response = await getProjectStatusPending(5, 1)
      // console.log('response getProjectStatusPending', response)
      setSchema(response)
    } catch (e) {
      setError({})
    }
    // doneLoading()
    setloading(false)
  }

  const handleGetProjectStatusPending = async (pagesize, pagenumber, status) => {
    // console.log('handleGetProjectStatusPending => ', pagesize, pagenumber, status)
    // startLoading()
    setloading(true)
    try {
      // const response = await getProjectStatusPending(pagesize, pagenumber)
      if (status === 'all') {
        const response = await getProjectStatusPending(pagesize, pagenumber)
        if (response) {
          setSchema(response)
        }
      } else {
        const response = await searchProjectStatusPending(pagesize, pagenumber, status)
        // console.log('response getWaitScrutinize', response)
        if (response) {
          setSchema(response)
        }
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    // doneLoading()
  }

  const handleSearchStatus = async (pagesize, pagenumber, status) => {
    // console.log('handleSearchStatus => ', pagesize, pagenumber, status)
    // startLoading()
    setloading(true)
    try {
      let response
      if (status === 'all') {
        response = await getProjectStatusPending(pagesize, pagenumber)
      } else {
        response = await searchProjectStatusPending(5, 1, status)
      }

      // console.log('response searchProjectStatusPending', response)
      if (response) {
        setSchema(response)
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    // doneLoading()
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}

          <ProjectStatusDataTable
            schema={schema}
            pagination={true}
            onReload={handleGetProjectStatusPending}
            onSearchStatus={handleSearchStatus}
            loading={loading}
            setting={config && true}
          />
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'โครงการรอดำเนินการ',
  projectCodeText: 'รหัสโครงการ',
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectStatusText: 'สถานะ',
  projectEditVerText: 'แก้ไขล่าสุด',
  totalSize: 1,
  buttonFilterStatus: [
    { buttonText: 'คัดกรอง', countStatus: 1, colorStatus: '#B7CFB7', status: '3' },
    { buttonText: 'กลั่นกรอง', countStatus: 1, colorStatus: '#97C1A9', status: '4' },
    { buttonText: 'อนุมัติ/รอทำสัญญา', countStatus: 1, colorStatus: '#B5EAD6', status: '5' },
    { buttonText: 'ดำเนินการ', countStatus: 1, colorStatus: '#9AB7D3', status: '6' },
  ],
  values: [
    {
      projectVersionId: '',
      code: 'XX-XXXXX',
      type: { icon: 'file-o', label: 'โครงการ' },
      projectName: { name: 'โครงการ XXXXX', statusName: 'สถานะ XXXXX' },
      status: 'ดำเนินการ',
      colorstatus: { code: '#9AB7D3', label: 'สถานะ XXXXX' },
      date: 'V.X DD/MM/YYYY HH:MM',
    },
  ],
}
